
import * as appsettings from "../appsettings";
import * as form        from "../form";
import * as moment      from "moment";
import * as validation from "../validation";
import * as helpers from "../helpers";

// Used to determ if a selection has been made when mouseUp.
let dragdropselection = false;

// Dragging (mouse) selection start datetime and stop datetime.
let startSelection: Date = new Date(Date.now());
let stopSelection: Date = new Date(Date.now());

// selection function+userid ('3_32') and user for the new appointment (piket)
let userServiceFunctionCombinedID = "0";

// Selection of start and end datetime (kendo scheduler)
let startDateScheduler = (moment().utc().unix() * 1000);
let endDateScheduler = (moment().utc().add(1, 'days').unix() * 1000);

// States (used to know what to do in certain situations)
let deleteAppointment = false;
let updateAppointment = false;
let insertAppointment = false;
let cancelAppointment = false;
let eventChangeRunOnce = false;

// scheduler data (public)
let schedulerData: kendo.data.ObservableArray = null;

// selection of repeating the appointment
let interval = 1;
let frequantie = "None";
let numberEvents = 0;
let repeatUntil = Date.now();
let mondaySelected = false;
let tuesdaySelected = false;
let wednesdaySelected = false;
let thursdaySelected = false;
let fridaySelected = false;
let saterdaySelected = false;
let sundaySelected = false;

// refresh
let redraw = true;
let refreshData = true;

// debugging
let debug = false;

// disable scheduler
let _disable = false;

let initialized = false;
let isAdmin = false;

function debugConsole(message: string): void {
    if (debug) console.log(message);
}

function getDateTimeSelectionPiketScheduler(): { begin: Date; end: Date } {
    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    let startDate = moment().toDate();
    let endDate = moment().add(1, 'days').toDate();
    let result: { begin: Date; end: Date } | null = null;

    if (scheduler.view() != undefined) {
        startDate = scheduler.view().startDate();
        endDate = scheduler.view().endDate();

        let startTime = 0;
        let endTime = 0;

        const view = scheduler.view() as kendo.ui.SchedulerView;

        if ("startTime" in view && "endTime" in view) {
            const v = view as SchedulerViewWithTime;

            startTime = kendo.date.getMilliseconds(v.startTime());
            endTime = kendo.date.getMilliseconds(v.endTime());
            endTime = endTime === 0 ? kendo.date.MS_PER_DAY : endTime;
        }

        result = {
            begin: new Date(startDate.getTime() - (startDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + startTime),
            end: new Date(endDate.getTime() - (endDate.getTimezoneOffset() * kendo.date.MS_PER_MINUTE) + endTime)
        }
    }

    return result;
}

function defineStartAndEndDateTimeSelection(e: kendo.ui.SchedulerNavigateEvent): void {
    // Update selection while navigating (not working, not getting the new selection but the current selection -> start and end datetime)
    let view: kendo.ui.SchedulerView = e.sender.view();

    startDateScheduler = e.date.getTime();

    let scheduler: kendo.ui.Scheduler = $("#piket-scheduler").data("kendoScheduler");

    // Reset to begin of the day
    startDateScheduler = moment(startDateScheduler).startOf('day').unix() * 1000;

    // Great that Kendo does not give a end selection datetime. Use momentjs for the calculation of the end datetime.
    switch (e.view) {

        case "timelineWeek":
            const timelineWeekOptions = scheduler.options.views.find((v: any ) => v.type === "timelineWeek" || v === "timelineWeek");
            const startTime = timelineWeekOptions && timelineWeekOptions.startTime ? timelineWeekOptions.startTime : new Date(0, 0, 0, 0, 0, 0);
            const endTime = timelineWeekOptions && timelineWeekOptions.endTime ? timelineWeekOptions.endTime : new Date(0, 0, 0, 23, 59, 59);

            if (e.action == "previous") {
                startDateScheduler = moment(getDateTimeKendo(view.startDate(), startTime).getTime()).add(-7, 'days').unix() * 1000;
                endDateScheduler = moment(getDateTimeKendo(view.endDate(), endTime).getTime()).add(-7, 'days').unix() * 1000;
            } else if (e.action == "next") {
                startDateScheduler = moment(getDateTimeKendo(view.startDate(), startTime).getTime()).add(7, 'days').unix() * 1000;
                endDateScheduler = moment(getDateTimeKendo(view.endDate(), endTime).getTime()).add(7, 'days').unix() * 1000;
            } else if (e.action == "changeView") {
                startDateScheduler = moment(getDateTimeKendo(view.startDate(), startTime).getTime()).startOf('week').startOf('hour').unix() * 1000;
                endDateScheduler = moment(getDateTimeKendo(view.endDate(), endTime).getTime()).add(7, 'days').unix() * 1000;
            }
            break;

        default:
            endDateScheduler = moment(startDateScheduler).add(1, 'days').unix() * 1000;
            break;
    }
}

// Given date not between 'no available'
function isFree(date: Date, userID: number): boolean {
    debugConsole("Check before showing add dialog if the selection is free.");
    for (let i = 0; i < schedulerData.length; i++) {
        // Check if the owner is right (userID) and the planned appointment is indeed a not available appointment given by the older scheduler.
        if (schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '0') {
            let start = schedulerData[i].Start.match(/\d/g);
            start = parseInt(start.join(""));

            let end = schedulerData[i].End.match(/\d/g);
            end = parseInt(end.join(""));

            let time = date.getTime();

            if (time >= start && time <= end) {
                // The user is not available
                return false;
            }
        }
    }

    // The user is available
    return true;
}

// Final check if the use has drawn over a 'no available area', returns true if it does contain a periode of 'no available'. If not false.
function startAndEndTimesContainNoAvailable(beginSelectionTime: number, endSelectionTime: number, userID: number): boolean {
    for (let i = 0; i < schedulerData.length; i++) {
        // Check if the owner is right (userID) and the planned appointment is indeed a not available appointment given by the older scheduler.
        if (schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '0' ||  // not available
            schedulerData[i].OwnerID == userID && schedulerData[i].ServiceFunctionUser.split('_')[0] === '-1') { // adhoc not available
            let start = schedulerData[i].Start.match(/\d/g);
            start = parseInt(start.join(""));

            let end = schedulerData[i].End.match(/\d/g);
            end = parseInt(end.join(""));

            if (beginSelectionTime < start && endSelectionTime > end) {
                // The user is not available
                return false;
            }
        }
    }

    // The user is available
    return true;
}

// When creating a new piket, check if the user has already a planned piket on a other function
function isNotAvailable(userServiceFunctionCombinedID: string, startSelection: Date, stopSelection: Date): boolean {

    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    const scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

    let result = false;
    scheduled.forEach(function (element: AvicSchedulerEvent) {
        if (element.AppointmentID === 0 && parseInt(element.ServiceFunctionUser.split('_')[1]) === parseInt(userServiceFunctionCombinedID.split('_')[1])) {
            result = true;
        }
    });

    return result;
}

// Find the selected values (weekdays array). Every selected day (checkbox) will return a value (integer)
function findMatchWithValue(valueDay: number, myArray: WeekDay[]): boolean {
    if (!myArray) return false;

    for (let i = 0; i < myArray.length; i++) {
        if (myArray[i].day === valueDay) {
            return true;
        }
    }

    return false;
}


// Called when the Recurrence settings change
// 'any' because the kendo event does not give the changed values in the event but in a property of the sender (_value)
function updateRecurrenceVariables(event: any): void {

    const changedValues = event.sender._value as ChangedValues;             

    const endAfterCountIsChecked = $('input[class~="k-recur-end-count"]:checked')[0] != undefined;
    const endAfterDateIsChecked = $('input[class~="k-recur-end-until"]:checked')[0] != undefined;

    if (changedValues.freq === "weekly") {
        $(".k-recur-end-never").closest("li").hide();
        $("#endPiket").hide();
    } else {
        $("#endPiket").show();
    }

    if (endAfterCountIsChecked) {
        numberEvents = changedValues.count;
    } else {
        numberEvents = 0;
    }

    if (changedValues.interval === undefined) {
        changedValues.interval = 1;
    }

    if (changedValues.until !== undefined && changedValues.until !== null) {
        repeatUntil = changedValues.until.getTime();
    }

    interval = changedValues.interval;
    frequantie = changedValues.freq;

    mondaySelected = findMatchWithValue(1, changedValues.weekDays);
    tuesdaySelected = findMatchWithValue(2, changedValues.weekDays);
    wednesdaySelected = findMatchWithValue(3, changedValues.weekDays);
    thursdaySelected = findMatchWithValue(4, changedValues.weekDays);
    fridaySelected = findMatchWithValue(5, changedValues.weekDays);
    saterdaySelected = findMatchWithValue(6, changedValues.weekDays);
    sundaySelected = findMatchWithValue(0, changedValues.weekDays);

    if (changedValues.freq === "weekly" && !endAfterCountIsChecked && !endAfterDateIsChecked) {
        $("button[class~='k-scheduler-update']").attr("disabled", "disabled");
    }
    else {
        $("button[class~='k-scheduler-update']").removeAttr("disabled");
    }
}

/**
* Get the settings filled in the generated form. 
*/
function GetShiftWorkDaySettings(amountOfDays: number): Array<{ Day: number, MomentNbr: number, TimeFrom: number, TimeTo: number }> {
    const arrFromTo: Array<{ Day: number, MomentNbr: number, TimeFrom: number, TimeTo: number }> = [];

    // Loop through input fields for the repeated moments.
    for (let row = 1; row <= amountOfDays; row++) {

        for (var numMoment = 1; numMoment <= 3; numMoment++) {
            var valueResult = ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker") != undefined &&
                $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value() != null &&
                $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker") != undefined &&
                $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value() != null);

            if (valueResult) {
                var obj = {
                    Day: row,
                    MomentNbr: numMoment,
                    TimeFrom: ($("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_From").data("kendoTimePicker").value().getMinutes(),
                    TimeTo: ($("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getHours() * 60) + $("#" + row + "_" + numMoment + "_To").data("kendoTimePicker").value().getMinutes()
                };

                arrFromTo.push(obj);
            }
        }
    }

    return arrFromTo;
}

/**
* Submit formshift (custom and not handled by the taghelper because of the dynamic generated form and values presented in the form)
* @param {any} e
*/
function onFormSubmit_FormShift(vm: vmModel): void {

    const groupId = parseInt($("#selectedGroupId").data("kendoDropDownList").value());

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserScheduler/SaveSettingsShifts"),
        data: {
            ShiftWorkID: vm.model.ShiftWorkID,
            UserID: vm.model.UserID,
            AmountOfDays: vm.model.AmountOfDays,
            ShiftType: vm.model.ShiftType,
            StartDate: vm.model.StartDate,
            EndDate: vm.model.EndDate,
            ShiftWorkDays: GetShiftWorkDaySettings(vm.model.AmountOfDays),
            SchedulerType: 2, // PiketScheduler
            IsAdmin: vm.model.IsAdmin
        },
        success: function (responseData) {
            if (responseData.Succesfully) {
                $('#ShiftWorkID').val(responseData.Id);

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("UserPiketScheduler/FormShift?userId=" + vm.model.UserID + "&groupId=" + groupId),

                    success: function (responseData) {
                        $("#PloegenScheduleWindow").html(responseData);
                    }
                });

                form.showServerResponse("", responseData, function () { });
            } else {
                $('#ShiftWarning').text(responseData.Message)
            }
        }
    });
}


export function initialize(disabled: boolean): void {

    _disable = disabled;

    refreshData = true;
    redraw = true;

    if (_disable) {
        $("#piket-scheduler").attr("disabled", "disabled");
    } else {
        $("#piket-scheduler").removeAttr("disabled");
    }

    //Open ploegen schedule
    $("#showPloegenSchedulerDialogBtn").on("click", function () {
        $("#PloegenScheduleWindow").data("kendoWindow").center().open();
    });
}

export function getDateTimeKendo(date: Date, time: Date): Date {
    date = new Date(date);

    // Why calculate milsecs ?
    let milsecs: number = (time.getHours() * kendo.date.MS_PER_HOUR) +
        (time.getMinutes() * kendo.date.MS_PER_MINUTE) +
        (time.getSeconds() * 1000);

    if (!milsecs) {
        milsecs = kendo.date.MS_PER_DAY - 1;
    }

    date.setTime(date.getTime());

    return date;
}

export function onAdd(e: kendo.ui.SchedulerAddEvent): void {
    // Selection (has an appointment already, cannot plan another appointment/piket)
    let appointmentInSelectedUserFunction = false;
    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    const scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

    scheduled.forEach(function (element: any) {
        if (element.ServiceFunctionUser === userServiceFunctionCombinedID) {
            appointmentInSelectedUserFunction = true;
        }
    });

    if (appointmentInSelectedUserFunction) {
        e.preventDefault();
    }
}

export function onNavigate(e: kendo.ui.SchedulerNavigateEvent): void {
    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    scheduler.select(null);

    defineStartAndEndDateTimeSelection(e);

    // Allow to refresh the background and get new data 
    refreshData = true;
    redraw = true;
}

export function onEdit(e: kendo.ui.SchedulerEditEvent): void {
    const container = e.container;
    const recurrenceEditor = container.find("[data-role=recurrenceeditor]").data("kendoRecurrenceEditor");

    const event = e.event as AvicSchedulerEvent

    if (event.appointmentId == 0) {
        //If new apointment
        $("#takeover").hide();
        $("#RepeatPiket").show();
    } else {
        //Get possible users for take over
        const dataSource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: appsettings.getUrl("UserPiketScheduler/GetFunctionUsers") + "?appointmentId=" + event.appointmentId,
                    contentType: 'application/json; charset=utf-8'
                }
            },
            schema: {
                data: function (response: any) {
                    const functionUsers = [];
                    for (let i = 0; i < response.length; i++) {
                        const functionUser = {
                            Value: response[i].UserID,
                            Text: response[i].FullName
                        };
                        functionUsers.push(functionUser);
                    }
                    return functionUsers;
                }
            },
        });
        $("#usersDropdown").kendoDropDownList({
            dataTextField: "Text",
            dataValueField: "Value",
            dataSource: dataSource
        });

        const dropdownlist = $("#usersDropdown").data("kendoDropDownList");
        if (dropdownlist !== undefined) {
            dropdownlist.one("dataBound", () => {
                dropdownlist.select(function (dataItem: any) {
                    return dataItem.Value === event.ownerId;
                });
            });
        }

        $("#users").hide();
        $("#allgroups").prop("checked", event.isAllGroups);
        $("#allgroups").attr("disabled", "disabled");
        $("#allgroups").removeClass("k-checkbox");
        $("#allgroups").addClass("k-checkbox-disabled");

        $("#RepeatPiket").hide();
    }

    recurrenceEditor.bind("change", function (e: any) {                 // any because the kendo event does not give the changed values in the event but in a property of the sender (_value) and typescript does not allow to access this property because it is private.
        updateRecurrenceVariables(e);   
    });

    // reset local vars
    interval = 1;
    frequantie = "None";
    numberEvents = 0;
    repeatUntil = Date.now();
    mondaySelected = false;
    tuesdaySelected = false;
    wednesdaySelected = false;
    thursdaySelected = false;
    fridaySelected = false;
    saterdaySelected = false;
    sundaySelected = false;
}

export function onSave(): void {
    redraw = true;
    refreshData = true;
}

export function onRemove(): void {
    redraw = true;
    refreshData = true;
}

export function onCancel(): void {
    cancelAppointment = true;
}

export function onError(args: kendo.data.DataSourceErrorEvent): void {
    //The event will fire when there are ModelState errors.
    const errors = args.errors as ModelStateErrors; //Get the received errors.
    let message = "";
    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    if (errors) {
        scheduler.one("dataBinding", function (e: kendo.ui.SchedulerDataBindingEvent) { //Subscribe to the "dataBinding" event of the Scheduler once.
            e.preventDefault(); //prevent the default event action
            $.each(errors, function (key, value) { //loop through the errors
                if ('errors' in value) {
                    $.each(value.errors, function () {
                        message += this + "\n"; //Store the message in a variable
                    });
                }

                // As long as the key matches the field name, this line of code will be displayed as validation message in the popup.
                //scheduler.editable.element.find("[data-for='" + key + "'].k-invalid-msg").replaceWith('<div class="k-widget k-tooltip k-tooltip-error" style="margin:0.5em"><span class="k-icon k-font-icon k-i-warning"> </span>' + message + '<div class="k-callout k-callout-n"></div></div>').show();
                $("#EWarning").text(message);
            });
        });
    }
}

export function changeHeightScheduler(h: number, maxh: number): void {
    if (h < maxh) {
        $("#piket-scheduler").data("kendoScheduler").element.height(h);
    } else {
        $("#piket-scheduler").data("kendoScheduler").element.height(maxh);
    }
    $("#piket-scheduler").data("kendoScheduler").resize(true);
}

// get the user functions for the new selected group
export function onChangeGroupId(e: kendo.ui.DropDownListChangeEvent): void {

    const groupId = Number(e.sender.value());
    const selection = getDateTimeSelectionPiketScheduler();

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("UserPiketScheduler/GetUserFunctions") + "?groupId=" + groupId + "&begin=" + selection.begin.getTime() + "&end=" + selection.end.getTime(),
        success: function (responseData) {

            _disable = responseData.Disabled;

            if (_disable) {
                $("#piket-scheduler").attr("disabled", "disabled");
            } else {
                $("#piket-scheduler").removeAttr("disabled");
            }

            // replenish the data resources
            $("#piket-scheduler").data("kendoScheduler").resources[0].dataSource.transport.data = responseData.SchedulerResources;

            // Reset var to redraw the background of the scheduler.
            redraw = true;
            refreshData = true;

            // after replenish, read/construct new userfunctions and read new data from the scheduler. 
            $("#piket-scheduler").data("kendoScheduler").resources[0].dataSource.read();
            $("#piket-scheduler").data("kendoScheduler").dataSource.read();
        }
    });

    getGroupUsers(groupId);
}

// Scheduler change
export function scheduler_change(e: kendo.ui.SchedulerChangeEvent): void {
    startSelection = e.start;
    stopSelection = e.end;
    userServiceFunctionCombinedID = e.resources.ServiceFunctionUser;

    if (eventChangeRunOnce === false) {
        if (e.events.length === 0 && deleteAppointment === false && updateAppointment === false && insertAppointment === false && cancelAppointment === false) {
            dragdropselection = true;
        } else {
            // set false
            deleteAppointment = false;
            updateAppointment = false;
            insertAppointment = false;
            cancelAppointment = false;

            // run the event change not for a second time !
            eventChangeRunOnce = true;
        }
    } else {
        // deselect all selections in the scheduler (if any)
        eventChangeRunOnce = false;
    }
}

// When creating a new piket, check if the user has already a planned piket on a other function
export function isPlannedAlreadyForOtherFunction(userServiceFunctionCombinedID: string, startSelection: Date, stopSelection: Date): boolean {
    const scheduler = $("#piket-scheduler").data("kendoScheduler");
    const scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

    let result = false;
    scheduled.forEach((element: AvicSchedulerEvent) => {
        if (element.appointmentId !== 0) {
            if (parseInt(element.ServiceFunctionUser.split('_')[1]) === parseInt(userServiceFunctionCombinedID.split('_')[1])) {
                result = true;
            }
        }
    });

    return result;
}

// Fired up when the mouse button is released. Checks if any action is needed.
export function mouseUp(): void {

    if (userServiceFunctionCombinedID !== ""
        && dragdropselection
        && isFree(startSelection, parseInt(userServiceFunctionCombinedID.split('_')[1]))
        && isFree(stopSelection, parseInt(userServiceFunctionCombinedID.split('_')[1]))
        && startAndEndTimesContainNoAvailable(startSelection.getTime(), stopSelection.getTime(), parseInt(userServiceFunctionCombinedID.split('_')[1]))) {

        const scheduler = $("#piket-scheduler").data("kendoScheduler");
        const scheduled = scheduler.occurrencesInRange(startSelection, stopSelection);

        // Selection (has an appointment already, cannot plan another appointment/piket)
        let appointmentInSelectedUserFunction = false;

        scheduled.forEach(function (element: AvicSchedulerEvent) {
            if (element.ServiceFunctionUser === userServiceFunctionCombinedID) {
                appointmentInSelectedUserFunction = true;
            }
        });

        // Cannot add on
        if (scheduled && !appointmentInSelectedUserFunction) {
            if (!isNotAvailable(userServiceFunctionCombinedID, startSelection, stopSelection)) {
                scheduler.addEvent({ title: "", start: startSelection, end: stopSelection, ServiceFunctionUser: userServiceFunctionCombinedID });
                dragdropselection = false;

                $("#enddate").on("change", function () {
                    // als eind kleiner is dan de begin datum correctie
                    if (moment($('#enddate').data("kendoDateTimePicker").value()).unix() <
                        moment($('#begindate').data("kendoDateTimePicker").value()).unix()) {
                        const begindate = moment($('#begindate').data("kendoDateTimePicker").value());
                        const newdate = begindate.add(1, 'days').toDate();
                        $('#enddate').data("kendoDateTimePicker").value(newdate);
                    }
                });

                $("#begindate").on("change", function () {
                    // als eind kleiner is dan de begin datum correctie
                    if (moment($('#enddate').data("kendoDateTimePicker").value()).unix() <
                        moment($('#begindate').data("kendoDateTimePicker").value()).unix()) {
                        const enddate = moment($('#enddate').data("kendoDateTimePicker").value());
                        const newdate = enddate.subtract(1, 'days').toDate();
                        $('#begindate').data("kendoDateTimePicker").value(newdate);
                    }
                });

                // reset local vars
                interval = 1;
                frequantie = "None";
                numberEvents = 0;
                repeatUntil = Date.now();
                mondaySelected = false;
                tuesdaySelected = false;
                wednesdaySelected = false;
                thursdaySelected = false;
                fridaySelected = false;
                saterdaySelected = false;
                sundaySelected = false;
            }
        }
    }
}

export function scheduler_redraw(): void {
    if (redraw) {
        var schedulerPiket = $("#piket-scheduler").data("kendoScheduler");
        schedulerPiket.view(schedulerPiket.view().name);
        redraw = false;
        refreshData = false;
    }
}

// Paint the background with some color
export function getColorBasedOnHour(date: Date, resources: SchedulerSlotResources): string {

    // Get current data from the scheduler.
    schedulerData = $("#piket-scheduler").data("kendoScheduler").dataSource.data();

    // Check if the data is received.
    if (schedulerData != null
        && schedulerData != undefined
        && schedulerData.length > 0
        && resources.ServiceFunctionUser != null
        && resources.ServiceFunctionUser != undefined) {

        // Get userId
        const userID = parseInt(resources.ServiceFunctionUser.split('_')[1]);
        const time = date.getTime();

        for (let i = 0; i < schedulerData.length; i++) {

            // Check if the owner is right (userID)
            if (schedulerData[i].ownerId == userID) {

                const start = Date.parse(schedulerData[i].start);
                const end = Date.parse(schedulerData[i].end);

                if (time >= start && time < end) {
                    // Is NOT available
                    const appointmentType = schedulerData[i].ServiceFunctionUser.split('_')[0];

                    switch (appointmentType) {
                        case '-1': return "k-schedule-hour-notavailableadhoc";
                        case '0': return "k-schedule-hour-notavailable";        // the planned appointment is indeed a not available appointment given by the older scheduler
                    }
                }
            }
        }
    }

    // Is available
    return "k-schedule-hour-available";
}

export function getAdditionalData(): { begin: Date, end: Date, groupId: number, refreshData: boolean } {
    const piketScheduler = getDateTimeSelectionPiketScheduler();

    return {
        begin: piketScheduler.begin,
        end: piketScheduler.end,
        groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
        refreshData: refreshData
    }
}

export function createPiketAdditionalData(): {
    groupId: number,
    begin: number,
    end: number,
    until: number,
    numberEvents: number,
    isWeeklyRepeat: boolean,
    repeatEveryNumberOfWeeks: number,
    isSelectedMonday: boolean,
    isSelectedTuesday: boolean,
    isSelectedWednesday: boolean,
    isSelectedThursday: boolean,
    isSelectedFriday: boolean,
    isSelectedSaterday: boolean,
    isSelectedSunday: boolean
} {
    return {
        groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
        begin: $('#begindate').data("kendoDateTimePicker").value().getTime(),
        end: $('#enddate').data("kendoDateTimePicker").value().getTime(),
        until: repeatUntil,
        numberEvents: numberEvents,
        isWeeklyRepeat: frequantie === "weekly",
        repeatEveryNumberOfWeeks: $("#recur_interval").length > 0 ? $("#recur_interval").data("kendoNumericTextBox").value() : 1,
        isSelectedMonday: mondaySelected,
        isSelectedTuesday: tuesdaySelected,
        isSelectedWednesday: wednesdaySelected,
        isSelectedThursday: thursdaySelected,
        isSelectedFriday: fridaySelected,
        isSelectedSaterday: saterdaySelected,
        isSelectedSunday: sundaySelected
    }
}

export function updatePiketAdditionalData(e: AvicSchedulerEvent): {
    groupId: number,
    ScheduleAppointmentID: any,
    serviceFunctionUser: any,
    begin: number,
    end: number,
    TakeOver: boolean,
    UserID: number
} {
    let newUser: number;
    let takeover = false;
    const usersDropdownList = $("#usersDropdown").data("kendoDropDownList");

    if (usersDropdownList) {
        newUser = parseInt(usersDropdownList.value());
    }

    if (newUser != undefined && newUser != e.OwnerID && $("#users").is(":visible")) {
        takeover = true;
    }

    return {
        groupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
        ScheduleAppointmentID: e.AppointmentID,
        serviceFunctionUser: e.ServiceFunctionUser,
        begin: e.Start.getTime(),
        end: e.End.getTime(),
        TakeOver: takeover,
        UserID: newUser
    }
}

export function deletePiketAdditionalData(e: AvicSchedulerEvent): { ScheduleAppointmentID: number } {
    return {
        ScheduleAppointmentID: e.AppointmentID,
    }
}

export function onClickTakeOver(): void {
    const visible = $("#users").is(":visible");

    if (visible == true) {
        $("#RepeatPiket").show();
        $("#PiketWarning").show();
        $("#users").hide();
    } else {
        $("#RepeatPiket").hide();
        $("#PiketWarning").hide();
        $("#users").show();
    }
}

export function initFormShiftWork(): void {
    //Get users from selected group
    let groupId: number = parseInt($("#selectedGroupId").data("kendoDropDownList").value());
    this.getGroupUsers(groupId);

    $("#usersDropdownList").on("change", this.getSelectedUserFunctions);

    const dropdownlist = $("#usersDropdownList").data("kendoDropDownList");

    if (dropdownlist !== undefined) {
        dropdownlist.one("dataBound", () => {
            this.getSelectedUserFunctions();
            initialized = false;
            const users = $("#usersDropdownList").data("kendoDropDownList").items();
            if (users.length > 1) {
                isAdmin = true;
            }
            if (!isAdmin) {
                var startDateTimePicker = $("#StartDate").data("kendoDateTimePicker");
                if (startDateTimePicker != undefined) {
                    var now = new Date(Date.now());
                    var round = kendo.date.MS_PER_MINUTE * 15;
                    var date = new Date(Math.floor(now.getTime() / round) * round);
                    startDateTimePicker.min(date);
                }
            }
        });
    }

    $("#SchedulePlanningButtonLoader").hide();

    $("#SchedulePlanningButton").on("click", function () {
        $("#SchedulePlanningButtonLoader").show();

        const userId = parseInt($("#usersDropdownList").data("kendoDropDownList").value());

        //Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("UserPiketScheduler/PlanShifts"),
            data: {
                ShiftWorkID: -1,
                UserID: userId,
                AmountOfDays: $("#AmountOfDays").data("kendoNumericTextBox").value(),
                ShiftType: parseInt($("#ShiftType").data("kendoDropDownList").value()),
                StartDate: $("#StartDate").data("kendoDateTimePicker").value().toDateString(),
                EndDate: $("#EndDate").data("kendoDateTimePicker").value().toDateString(),
                ShiftWorkDays: GetShiftWorkDaySettings($("#AmountOfDays").data("kendoNumericTextBox").value()),
                //Extra piket data
                SchedulerType: 2, // PiketScheduler
                SelectedFunction: parseInt($("#functionsDropdownList").data("kendoDropDownList").value()),
                GroupId: parseInt($("#selectedGroupId").data("kendoDropDownList").value()),
                IsAdmin: isAdmin
            },
            success: function (responseData: responseModel | undefined| null) {
                if (responseData.Succesfully) {
                    redraw = true;
                    refreshData = true;

                    $("#piket-scheduler").data("kendoScheduler").dataSource.read();   // refresh scheduler

                    $("#SchedulePlanningButtonLoader").hide();

                    $('#ShiftWarning').text("")
                    //Close dialog
                    $("#PloegenScheduleWindow").data("kendoWindow").close();
                } else {
                    $("#SchedulePlanningButtonLoader").hide();
                    $('#ShiftWarning').text(responseData.Message)
                }
            },

            error: function () {
                $("#SchedulePlanningButtonLoader").hide();
            }
        });
    });

    // Form Submit ajax call
    $('#formUserScheduler_FormShift').on('submit', function (event) {
        // Prevent default
        event.preventDefault();

        // Make model to send.
        let vm: vmModel = new class implements vmModel {
            preventDefault = event.preventDefault;
            model: {
                ShiftWorkID: number,
                AmountOfDays: number,
                ShiftType: number,
                StartDate: Date,
                EndDate: Date,
                UserID: number,
                IsAdmin: boolean
            }
        };

        const startDate = $(event.currentTarget).find("#StartDate").data("kendoDateTimePicker").value();
        const endDate = $(event.currentTarget).find("#EndDate").data("kendoDateTimePicker").value();
        
        // Model
        vm.model = {
            ShiftWorkID: Number($('#ShiftWorkID').val()),
            AmountOfDays: Number($(event.currentTarget).find("#AmountOfDays").val()),
            ShiftType: Number($(event.currentTarget).find("#ShiftType").val()),
            StartDate: startDate,
            EndDate: endDate,
            UserID: parseInt($("#usersDropdownList").data("kendoDropDownList").value()),
            IsAdmin: isAdmin
        };

        // Fire event
        onFormSubmit_FormShift(vm);
    });

    // Set validation config
    $('#formUserScheduler_FormShift').kendoValidator(validation.getConfiguration());
}

export function getGroupUsers(groupId: number): void {

    let dataSource = new kendo.data.DataSource({
        transport: {
            read: {
                url: appsettings.getUrl("UserPiketScheduler/GetGroupUsers") + "?groupId=" + groupId,
                contentType: 'application/json; charset=utf-8'
            }
        },
        schema: {
            data: function (response: any) {
                let users = [];
                for (let i = 0; i < response.length; i++) {
                    let user = {
                        Value: response[i].UserID,
                        Text: response[i].FullName
                    };
                    users.push(user);
                }
                return users;
            }
        },
    });

    $("#usersDropdownList").kendoDropDownList({
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource: dataSource,
        filter: "contains"
    });
}

export function getSelectedUserFunctions(): void {

    //Get functions of the selected user in the selected group
    const userId = parseInt($("#usersDropdownList").data("kendoDropDownList").value());
    const groupId = parseInt($("#selectedGroupId").data("kendoDropDownList").value());

    const dataSource = new kendo.data.DataSource({
        transport: {
            read: {
                url: appsettings.getUrl("UserPiketScheduler/GetSelectedUserFunctions") + "?userId=" + userId + "&groupId=" + groupId,
                contentType: 'application/json; charset=utf-8',
                type: "GET"
            }
        },
        schema: {
            data: function (response: any) {
                const functions = [];
                for (let i = 0; i < response.length; i++) {
                    const func = {
                        Value: response[i].ServiceFunctionID,
                        Text: response[i].Label
                    };
                    functions.push(func);
                }
                return functions;
            }
        },
    });

    $("#functionsDropdownList").kendoDropDownList({
        dataTextField: "Text",
        dataValueField: "Value",
        dataSource: dataSource
    });

    if (!initialized) {
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("UserPiketScheduler/FormShift?userId=" + userId + "&groupId=" + groupId),

            success: function (responseData) {
                initialized = true;
                $("#PloegenScheduleWindow").html(responseData);
            }
        });
    }
}
